"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc filter
 * @name common.filter:montant
 * @function
 *
 * @description
 * Formats a montant (ie. 1 234 567,12 €).
 * If montant is of ESTIME type, will add an '*' add the end of the formatted value.
 * If fixedDecimals is provided, will format using given fixed decimal number,
 * else will format using 2 optional decimals.
 *
 * @param {Montant} The montant to filter.
 * @param {number=} The optional number of fixed decimal to use.
 * @param {signed=} optional,  si présent et non à false met toujours le signe (+/- always displayed).
 * @param {unite=} optional,  si K ou M met en millier ou million.
 *
 * @returns {string} Formatted montant.
 */
ngModule.filter("montant", function ($montantFormat) {
  return function montantFilter(montant, fixedDecimals, signed, unite) {
    return $montantFormat.montant(montant, fixedDecimals, signed, unite);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/montant/montantFilter.js
// module id = 2730
// module chunks = 13